<div class="table-header d-flex justify-content-between align-items-center border-bottom">
    <button class="btn btn-outline-primary" (click)="settingsClicked.emit()">
      <clr-icon shape="cog"></clr-icon> Table Settings
    </button>
  
    <div class="d-flex">
      <button class="btn btn-primary d-flex align-items-center me-2"
              (click)="isEditingAll ? saveClicked.emit() : editClicked.emit()">
        <i class="fas" [ngClass]="{ 'fa-save': isEditingAll, 'fa-edit': !isEditingAll }"></i>
        <span class="ms-2">{{ isEditingAll ? 'Save Changes' : 'Edit' }}</span>
      </button>
  
      <button *ngIf="isEditingAll"
              class="btn btn-danger d-flex align-items-center"
              (click)="cancelClicked.emit()">
        <i class="fas fa-times"></i>
        <span class="ms-2">Cancel</span>
      </button>
  
      <button class="btn btn-primary d-flex align-items-center ms-2"
              *ngIf="showImportButton"
              (click)="searchClicked.emit()">
        <clr-icon shape="search"></clr-icon>
        <span class="ms-2">Search</span>
      </button>
  
      <label class="btn btn-outline-primary d-flex align-items-center ms-2 mb-0"
             *ngIf="showImportFileButton">
        <clr-icon shape="file"></clr-icon>
        <span class="ms-2">Import</span>
        <input type="file" (change)="fileUploaded.emit($event)" hidden>
      </label>
    </div>
  </div>
  
  <!-- Table Settings Modal -->
   <div class="header-modal">
  <clr-modal [(clrModalOpen)]="isSettingsOpen"  [clrModalClosable]="false" >
    <h3 class="modal-title mt-2">
      <clr-icon shape="settings" class="me-2"></clr-icon> Table Settings
    </h3>
  
    <div class="modal-body">
      <clr-tabs>
        <clr-tab>
          <button clrTabLink>Columns</button>
          <clr-tab-content clrTabContentActive>
            <ul class="columns-list mt-2 d-grid columns-grid">
              <li *ngFor="let col of columnsCopy" class="column-item">
                <div class="d-flex align-items-center">
                  <input type="checkbox" [(ngModel)]="col.visible" style="margin: 0 10px;">
                  <label class="form-check-label" style="margin: 0 10px;">{{ col.name }}</label>
                </div>
              </li>
            </ul>
          </clr-tab-content>
        </clr-tab>
  
        <clr-tab>
          <button clrTabLink>View</button>
          <clr-tab-content class="p-2">
            <ul class="columns-list mt-2">
              <li>
                <div class="d-flex align-items-center">
                  <input type="radio" [name]="'tableView-1-' + schemaName" [value]="false"
                         [(ngModel)]="tableVerticleView"
                         style="margin: 0px 10px;cursor:pointer">
                  <label class="form-check-label">Horizontal</label>
                </div>
              </li>
              <li>
                <div class="d-flex align-items-center">
                  <input type="radio" [name]="'tableView-2-' + schemaName" [value]="true"
                         [(ngModel)]="tableVerticleView"
                         style="margin: 0px 10px;cursor:pointer">
                  <label class="form-check-label">Vertical</label>
                </div>
              </li>
            </ul>
  
            <div class="mt-3" *ngIf="showEnableSummary">
              <div class="d-flex align-items-center justify-content-between w-100">
                <label class="mb-0">Enable Summary</label>
                <clr-toggle-wrapper>
                  <input type="checkbox" clrToggle [(ngModel)]="enableSummary" />
                </clr-toggle-wrapper>
              </div>
            </div>
  
            <div class="mt-3"  *ngIf="showEnableAdjustment">
              <div class="d-flex align-items-center justify-content-between w-100">
                <label class="mb-0">Enable Adjustment</label>
                <clr-toggle-wrapper>
                  <input type="checkbox" clrToggle [(ngModel)]="enableAdjustment" />
                </clr-toggle-wrapper>
              </div>
            </div>
          </clr-tab-content>
        </clr-tab>
      </clr-tabs>
    </div>
  
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="settingsClosed.emit()">Cancel</button>
      <button class="btn btn-primary" (click)="applySettings()">Apply</button>
    </div>
  </clr-modal>
</div>
  

  